module.exports = __webpack_public_path__ + "img/collapse-triangle.1e65bd61.svg";